import React from 'react';
import { PageLoader } from 'src/lib/PageLoader';

export const AsyncConsignmentNotableCollectorsPage = ({ ...props }): JSX.Element => (
  <PageLoader
    id='src/pages/ConsignmentNotableCollectors/ConsignmentNotableCollectorsPage'
    componentImport={async () => (await import('src/pages/ConsignmentNotableCollectors/ConsignmentNotableCollectorsPage'))}
    head={() => async () => {
      return {
        title: 'Where Legends Come to Sell',
        description: 'View our Notable Collectors directory to establish some value in consigning items with Rock Island Auction',
      };
    }}
    {...props}
  />
);
